import PropTypes from 'prop-types';
import React from 'react';
import { ErrorBoundary } from 'react-error-boundary';
import ErrorProvider from '../ErrorProvider';
import { LogoutButton } from '../components/ActionButtons';
import FullScreenError from '../components/FullScreenError';
const RootErrorProvider = ({ children })=>{
    return /*#__PURE__*/ React.createElement(ErrorBoundary, {
        fallbackRender: ({ error })=>/*#__PURE__*/ React.createElement(FullScreenError, {
                error: {
                    shortDescription: error.toString(),
                    longDescription: error.stack
                }
            })
    }, /*#__PURE__*/ React.createElement(ErrorProvider, {
        ModalErrorProviderProps: {
            actionButtonSingle: /*#__PURE__*/ React.createElement(LogoutButton, null)
        }
    }, children));
};
RootErrorProvider.propTypes = {
    children: PropTypes.node
};
export default RootErrorProvider;
